import { NotificationModel, PaginatedResponse } from '@arpeggi/shared'
import { useInfiniteQuery, UseInfiniteQueryOptions } from 'react-query'
import { getNextPage, getPreviousPage } from '../../../__legacy__/queries/common'
import { ApiService, GetNotificationsParams } from '../../api'

export const useNotifications = ({
  userId,
  params,
  options
}: {
  userId: number
  params: GetNotificationsParams
  options?: UseInfiniteQueryOptions<PaginatedResponse<NotificationModel>>
}) => {
  return useInfiniteQuery(
    ['notifications', params],
    ({ pageParam = params?.page || 1 }) =>
      ApiService.Notifications.endpoints.getMany(userId, { ...params, page: pageParam }),
    {
      getPreviousPageParam: (firstPage) => getPreviousPage(firstPage),
      getNextPageParam: (lastPage) => getNextPage(lastPage),
      ...options
    }
  )
}
